import React, { useEffect, useState } from 'react';
import { UserBusiness } from '../Classes';
import { Image, Placeholder, Stat } from 'react-frontier';
import { CDN_URL } from '../API';
import moment from 'moment';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

interface BusinessItemProps{
	small?: boolean,
	placeholder?: boolean,
	business?: UserBusiness,
	to?: string,
	onClick?: ()=> void,
}


var BusinessItem = (props: BusinessItemProps)=>{
	var { onClick } = props;

	if(props.placeholder){
		return <div className="tp business card placeholder">
			<div className="image"></div>
			<div className="info">
				<Placeholder className='name' height={24} minWidth={200} style={{ marginBottom: 5 }} />
				<Placeholder className='meta' width={80} style={{ marginBottom: 0 }} />
				<div className="stats">
					<Stat value={<Placeholder height={20} />} label={<Placeholder height={16} />} />
				</div>
			</div>
		</div>
	}
	if(!props.business) return null;

	const CONTENTS = <>
		<div className="image">
			<Image src={`${CDN_URL}/business/${props.business.business_id}/${props.small ? 'small' : 'large'}.webp`} fallbackComponent={(
				<i className='building icon' />
			)} />
		</div>
		<div className="info">
			<div className="name">{props.business.business_name}</div>
			<div className="meta">Desde {moment.unix(props.business.date_created).format('MMM YYYY')}</div>
			{!props.small && (
				<div className="stats">
					<Stat value={(props.business.postings || 0)} label={'Trabajos'} size='small' />
				</div>
			)}
		</div>
	</>

	if(props.to){
		return <Link className={classNames("tp business card", { small: props.small })} to={props.to}>
			{CONTENTS}
		</Link>
	}else{
		return <div className={classNames("tp business card", { small: props.small })} onClick={onClick}>
			{CONTENTS}
		</div>
	}

}

export default BusinessItem;